import React from 'react'
import update from 'immutability-helper';
import Modal from 'react-modal';
import { browserHistory } from 'react-router'

import { billing } from '../../core/controllers/Billing';
import { modal } from '../../core/utilities/modal';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { property } from '../../core/controllers/Property'
import { user } from '../../core/controllers/user'

import PropertiesSelect from '../Properties/PropertiesSelect.jsx';

export default class EditBankAccountForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accountName: props.bank ? props.bank.accountName : '',
            isBillingAccount: props.bank ? props.bank.billing : false,
            isPrimaryAccount: props.bank ? props.bank.default : false,
            bankId: props.bank ? props.bank.id : 0,
            status: props.bank ? props.bank.status : 0,
            showModal: false,
            deposit_one: '',
            deposit_two: '',
            disableChangePrimary: true,
            selectedProperty: null,
            property_id: props.property ? props.property.property_id : 0,
        };
    }

    componentDidMount() {
        var self = this;
        billing.getProfile(function(response) {
            if (response) {
                if (response.data.banks.length > 1) {
                    self.setState({
                        disableChangePrimary: false,
                    });
                }
            }
        });

        if (this.state.property_id != 0) {
            property.getProperty(this.state.property_id, function(response) {
                self.setState({
                    selectedProperty: response.data,
                    property_id: self.state.property_id
                });
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
    }

    validate() {
        const accountName = this.state.accountName;

        if (accountName == '') {
            modal.showInfo("Enter a bank label for this account.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    updateBankAccount() {
        if (!this.validate()) {
            return;
        }

        const bankAccount = {
            isBillingAccount: this.state.isBillingAccount,
            isPrimaryAccount: this.state.isPrimaryAccount,
            accountName: this.state.accountName,
            id: this.state.bankId,
            property_id: this.state.property_id,
        }

        modal.showDangerModalWithOK("Warning!","You are going to update this bank account.  Do you wish to continue?","Yes");
        jQuery(".move-on").on('click',function() {
            billing.updateBankAccount(bankAccount, function(response) {
                if (response.status == 'OK') {
                    modal.showInfo("Your bank account has been successfully updated!", "success", "top", "center");
                    browserHistory.replace('/account/billing');
                }
            });
        });
    }

    deleteBankAccount() {
        var self = this;
        modal.showDangerModalWithOK("Warning!","You are going to remove this bank account.  Do you wish to continue?","Yes");
        jQuery(".move-on").on('click',function() {
            billing.deleteBankAccount(self.state.bankId, function(response) {
                if (response.status == 'OK') {
                    modal.showInfo("Your bank account has been successfully removed!", "success", "top", "center");
                    browserHistory.replace('/account/billing');
                }
            });
        });
    }

    handleBankNameChange(e){
        this.setState({
            accountName: e.target.value
        });
    }

    changePrimaryAccount(e) {
        this.setState({
            isPrimaryAccount: e.target.value
        });
    }

    changeBillingAccount(e) {
        this.setState({
            isBillingAccount: e.target.value
        });
    }

    verifyAccount() {
        this.setState({
            showModal: true
        });
    }

    handleCloseModal(e) {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    handleDepostOneChange(e) {
        this.setState({
            deposit_one: e.target.value
        });
    }

    handleDepostTwoChange(e) {
        this.setState({
            deposit_two: e.target.value
        });
    }

    veryDeposit() {
        const depositOne = this.state.deposit_one;
        const depositTwo = this.state.deposit_two;
        const regex      = /^\d+(?:\.\d{0,2})$/;

        if(depositOne.includes("$") || depositTwo.includes("$")) {
            modal.showInfo("Enter only the number without the $ sign!", "warning", "top", "center");
            return;
        }

        if(depositOne[0] != 0 || !regex.test(depositOne)) {
            modal.showInfo("Enter a valid 1st deposit that starts with 0 and a period symbol! Example: 0.34", "warning", "top", "center");
            return;
        }

        if(depositTwo[0] != 0 || !regex.test(depositTwo)) {
            modal.showInfo("Enter a valid 2nd deposit that starts with 0 and a period symbol! Example: 0.15", "warning", "top", "center");
            return;
        }

        const bankAccount = {
            amount_1: depositOne,
            amount_2: depositTwo,
            bank_id: this.state.bankId
        }

        billing.verifyBank(bankAccount, function(response) {
            if (response.status == 'OK') {
                modal.showInfo("Your bank account has been successfully verified!", "success", "top", "center");
                browserHistory.replace('/account/billing');
            }
        });
    }

    handlePropertyChange(e) {
        var self = this;
        var value = e.target.value;
        if (value == 0) {
            self.setState({
                selectedProperty: null,
                property_id: 0,
            });
        } else {
            property.getProperty(value, function(response) {
                self.setState({
                    selectedProperty: response.data,
                    property_id: value
                });
            });
        }
    }

    render(){
        var self = this;
        const accountName               = this.state.accountName;
        const primaryAccount            = this.state.isPrimaryAccount;
        const status                    = this.state.status;
        const showModal                 = this.state.showModal;
        const deposit_one               = this.state.deposit_one;
        const deposit_two               = this.state.deposit_two;

        const selectedProperty          = this.state.selectedProperty;
        const propertyId                = this.state.property_id;

        return (
            <div>
            <div class="row blue-bottom-margin">
                <div class="content">
                    <div class="col-md-12 col-sm-12">
                        <div class="row">
                            <div class="header">
                                <span class="info-box-icon blue-icon-circle"><i class="icon-money-house-outline"></i></span>
                                <h4 class="title" style={{marginTop: '17px', marginLeft: '10px', float: 'left'}}>Bank Information</h4>
                                <p class="category"></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="phone">Banking label</label>
                                    <input type="text" value={accountName} class="form-control tenant-info" name="name" placeholder="Primary Checking" id="name" onChange={this.handleBankNameChange.bind(this)}/>
                                </div>
                            </div>
                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                <div class="form-group">
                                    <label for="phone">Is primary account?</label>
                                    <select class="form-control" disabled={this.state.disableChangePrimary} value={primaryAccount} onChange={this.changePrimaryAccount.bind(this)}>
                                        <option value="0">Select if primary account</option>
                                        <option value="true">Yes</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {user.userInfo.user_type_alias != 'tenant' && user.userInfo.user_type_alias != 'owner' && user.userInfo.user_type_alias != 'vendor' && (
                        <div>
                            <div class="row">
                                <div class="col-md-6 col-md-offset-3">
                                    <div class="form-group">
                                        <label>Property</label>
                                        <PropertiesSelect columnSize={0} sortID={propertyId} onChange={this.handlePropertyChange.bind(this)} />
                                    </div>
                                </div>
                            </div>
                            {selectedProperty != null && (
                            <div class="row">
                                <div class="col-md-9 col-md-offset-1">
                                    { selectedProperty.photo == null ? (
                                    <div class="property-photo">
                                        <p>No cover image.</p>
                                    </div>
                                    ) : (
                                    <div class="property-photo">
                                        <img src={selectedProperty.photo.url} width="100%" />
                                    </div>
                                    )}
                                    <div class="header">
                                        <h4 class="title">{selectedProperty.details.property_name}</h4>
                                        <p class="category">{selectedProperty.details.property_address}<br/>{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                        )}
                    </div>
                </div>
                <div class="row">
                </div>
            </div>
            <Modal
                isOpen={showModal}
                onRequestClose={this.handleCloseModal.bind(this)}
                style={modalStyles.getModalStyles()}
                ariaHideApp={false}
                >
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="header">
                            <span class="info-box-icon blue-icon-circle"><i class="pe-7s-piggy"></i></span>
                            <h4 class="title" style={{marginTop: '30px', marginLeft: '10px', float: 'left'}}>Verify micro-deposits</h4>
                            <p class="category"></p>
                        </div>
                    </div>
                    <div class="row">
                        <p>Enter the two micro-deposit amounts shown on your bank statement.</p>
                        <form>
                        <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                            <div class="form-group has-feedback">
                                <label for="first-deposit">1st Deposit Amount</label>
                                <input type="text" value={deposit_one} class="form-control input-group-dollar-addon" placeholder="0.34" onChange={this.handleDepostOneChange.bind(this)}/>
                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px", paddingTop:"25px"}}></i>
                                <p style={{color: "#9EA5BD", fontSize: "13px"}}>e.g. 0.34</p>
                            </div>
                        </div>
                        <div class="row"></div>
                        <div class="col-md-12 col-sm-12 col-xs-12" style={{paddingLeft: '0px'}}>
                            <div class="form-group has-feedback">
                                <label for="second-deposit">2nd Deposit Amount</label>
                                <input type="text" value={deposit_two} class="form-control input-group-dollar-addon" placeholder="0.15" onChange={this.handleDepostTwoChange.bind(this)}/>
                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px", paddingTop:"25px"}}></i>
                                <p style={{color: "#9EA5BD", fontSize: "13px"}}>e.g. 0.15</p>
                            </div>
                        </div>
                        <div class="col-md-2 col-md-offset-4 col-sm-2 col-sm-offset-4 col-xs-2 col-xs-offset-4">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-center" autoComplete="off" onClick={this.veryDeposit.bind(this)}>
                            Verify
                            </button>
                            <div class="clearfix"></div>
                        </div>
                        </form>
                    </div>
                </div>
            </Modal>
            <div class="row blue-bottom" style={{marginLeft:"-50px"}}>
                <div class="blue-bottom-center-align">
                    { status == 'PENDING' ? (
                        <div>
                        <div class="col-md-4 col-sm-4 col-xs-6 blue-bottom-btn-right-push">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateBankAccount.bind(this)}>
                            Update Account
                            </button>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-6" style={window.innerWidth < 768 ? {marginTop: "-20px"} : {}}>
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.verifyAccount.bind(this)}>
                            Verify Account
                            </button>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12 blue-bottom-btn-left-push">
                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteBankAccount.bind(this)}>
                            Unlink Account
                            </button>
                        </div>
                        </div>
                    ) : (
                        <div>
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.updateBankAccount.bind(this)}>
                            Update Account
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteBankAccount.bind(this)}>
                            Unlink Account
                            </button>
                        </div>
                        </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// app/components/Billing/EditBankAccountForm.jsx